<nav class="navbar navbar-expand-lg navbar-light bg-light px-4 w-100 navbar-custom" *ngIf="!isFromTapro">
  <div class="container-fluid">
 <!-- Left Section: Toggle Button -->
    <div class="admin-menu dropdown" *ngIf="!isFromTapro">
      <button class="btn btn-outline-secondary ms-2 d-flex flex-column align-items-center" (click)="logout()" title="Logout">
        <i class="bi bi-box-arrow-right" style="color: #dc3545; font-size: 1.5rem;"></i>
        <span style="color: #dc3545; font-size: 0.9rem;">Logout</span>
      </button>
    </div>

    <!-- Middle Section: Icon and Name -->
    <div class="navbar-brand-center" *ngIf="!isFromTapro">
      <img alt="Chevron" src="/assets/images/hallmark.png" width="42" height="46" class="d-inline-block align-top">
      <a [innerHTML]="'HEADER.LinkSchedulers' | translate" class="sitename light-blue font-gotham" [routerLink]="['']"></a>
    </div>

    <!-- Right Section: Login Name -->
    <div class="collapse navbar-collapse" id="navbarContent" *ngIf="!isFromTapro">
      <ul class="navbar-nav ms-auto mb-2 mb-lg-0">
        <li class="nav-item">
          <app-welcome></app-welcome>
        </li>
      </ul>
    </div>
  </div>
</nav>

<!-- Additional Navigation Menu -->
<div class="additional-nav" *ngIf="isAdminMenuVisible && !isFromTapro">
  <div class="container-fluid">
    <ul class="nav justify-content-center align-items-center">
      <li class="nav-item">
        <a class="nav-link" [routerLink]="['/admin/users']">{{'HEADER.UserMaintenance' | translate}}</a>
      </li>
      <li class="nav-item">
        <a class="nav-link" [routerLink]="['/admin/justifications']">{{'HEADER.JustificationReasons' | translate}}</a>
      </li>
      <li class="nav-item" *ngIf="isInstancesMaintenanceVisible">
        <a class="nav-link" [routerLink]="['/admin/instances']">{{'HEADER.InstancesMaintenance' | translate}}</a>
      </li>
      <li class="nav-item" *ngIf="isInstancesMaintenanceVisible">
        <a class="nav-link" [routerLink]="['/reporting/project-info']">{{'HEADER.ProjectInfo' | translate}}</a>
      </li>
      <li class="nav-item" *ngIf="isMasterDataSyncVisible">
        <a class="nav-link" (click)="this.displaySyncModal = true">Master Data Sync</a>
      </li>
      <li class="nav-item" *ngIf="isAdmin">
        <a class="nav-link" [routerLink]="['/admin/mobile-management']">Mobile Management</a>
      </li>
      <li class="nav-item" *ngIf="isAdmin">
        <a class="nav-link" [routerLink]="['/admin/projects-management']">{{'HEADER.ProjectsManagement' | translate}}</a>
      </li>
      <li class="nav-item dropdown" *ngIf="isAdmin && selectedProject">
        <a
          class="nav-link dropdown-toggle"
          href="#"
          id="projectsActionsDropdown"
          role="button"
          data-bs-toggle="dropdown"
          aria-expanded="false"
          (mouseover)="hoverProjectLevel()"
        >
          Projects Actions
        </a>
        <ul class="dropdown-menu" aria-labelledby="projectsActionsDropdown">
          <li>
            <a class="dropdown-item" [routerLink]="['/admin/language']">Language Preference</a>

          </li>
          <li>
            <a class="dropdown-item" [routerLink]="['/admin/team-communication']">Team Communication</a>
          </li>
         
        </ul>
      </li>
    </ul>
  </div>
</div>

<app-master-data-sync [(display)]="this.displaySyncModal"></app-master-data-sync>
